import { RouterLink } from '../types/router-link';
import { Guid } from '@web/utils';

export class Breadcrumb {
  public constructor(
    public readonly id: Guid,
    public readonly label: string,
    public readonly routerLink: RouterLink,
  ) {}
}
